import type { RouteLocationNormalized } from 'vue-router'
import { ERouterName } from '/@/types/enums'

/** 菜单 component 字段（path 可随意配，认组件地址） */
export const MAP_MANAGE_COMPONENT = 'robot-dog/mapManage'
export const MAP_DETAIL_COMPONENT = 'robot-dog/mapDetail'
export const MAP_MANAGE_CACHE_NAME = 'map_manage'

export const ROBOT_DOG_MEDIA_COMPONENT = 'robot-dog/mediaCenter'
export const ROBOT_DOG_MEDIA_CACHE_NAME = 'dog_media_center'
export const ROBOT_DOG_MEDIA_FILES_COMPONENT = 'robot-dog/media-files'
export const ROBOT_DOG_MEDIA_FILES_CACHE_NAME = 'dog_media_files'
export const ROBOT_DOG_MEDIA_ANNOTATOR_COMPONENT = 'robot-dog/imageAnnotator/index'

function getPageComponent (route: RouteLocationNormalized): string {
  const leaf = route.matched[route.matched.length - 1]
  const meta = leaf?.meta as { pageComponent?: string } | undefined
  return meta?.pageComponent || ''
}

export function isMapManageRoute (route: RouteLocationNormalized): boolean {
  return getPageComponent(route) === MAP_MANAGE_COMPONENT
}

export function isMapDetailRoute (route: RouteLocationNormalized): boolean {
  const meta = route.matched[route.matched.length - 1]?.meta as { isDetailPage?: boolean } | undefined
  if (meta?.isDetailPage) return true
  return getPageComponent(route) === MAP_DETAIL_COMPONENT
}

export function isMapFlowRoute (route: RouteLocationNormalized): boolean {
  return isMapManageRoute(route) || isMapDetailRoute(route)
}

export function isRobotDogMediaRoute (route: RouteLocationNormalized): boolean {
  const pageComponent = getPageComponent(route)
  return (
    pageComponent === ROBOT_DOG_MEDIA_COMPONENT ||
    normalizePath(route.path) === '/dog_media_center'
  )
}

export function isRobotDogMediaDetailRoute (route: RouteLocationNormalized): boolean {
  const meta = route.matched[route.matched.length - 1]?.meta as { isDetailPage?: boolean } | undefined
  if (!meta?.isDetailPage) return false
  const pageComponent = getPageComponent(route)
  return (
    pageComponent === ROBOT_DOG_MEDIA_FILES_COMPONENT ||
    String(route.name) === ERouterName.DOG_MEDIA_FILES
  )
}

export function isRobotDogMediaAnnotationRoute (route: RouteLocationNormalized): boolean {
  const pageComponent = getPageComponent(route)
  return (
    pageComponent === ROBOT_DOG_MEDIA_ANNOTATOR_COMPONENT ||
    String(route.name) === ERouterName.DOG_IMAGE_ANNOTATOR
  )
}

export function isRobotDogMediaFlowRoute (route: RouteLocationNormalized): boolean {
  return (
    isRobotDogMediaRoute(route) ||
    isRobotDogMediaDetailRoute(route) ||
    isRobotDogMediaAnnotationRoute(route)
  )
}

function normalizePath (path: string): string {
  if (!path) return ''
  let s = path.trim()
  if (!s.startsWith('/')) s = `/${s}`
  if (s.length > 1) s = s.replace(/\/+$/, '')
  return s
}

/** 动态路由注册时写入 meta，供 keep-alive 识别 */
export function applyRobotDogPageMeta (route: {
  component?: unknown
  meta?: Record<string, unknown>
}) {
  const pageComponent = typeof route.component === 'string' ? route.component : ''
  if (pageComponent === MAP_MANAGE_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, cacheName: MAP_MANAGE_CACHE_NAME }
  } else if (pageComponent === MAP_DETAIL_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, isDetailPage: true }
  } else if (pageComponent === ROBOT_DOG_MEDIA_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent, cacheName: ROBOT_DOG_MEDIA_CACHE_NAME }
  } else if (pageComponent === ROBOT_DOG_MEDIA_FILES_COMPONENT) {
    route.meta = {
      ...(route.meta || {}),
      pageComponent,
      cacheName: ROBOT_DOG_MEDIA_FILES_CACHE_NAME,
      isDetailPage: true,
    }
  } else if (pageComponent === ROBOT_DOG_MEDIA_ANNOTATOR_COMPONENT) {
    route.meta = { ...(route.meta || {}), pageComponent }
  }
}
